import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ROUTE_CONSTANTS } from '../../../util/route.constants';
import { environment } from '../../../../environments/environment';
import { CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { LoginService } from '../../../services/login/login.service';
import { CVA_CONSTANTS } from '../../../util/constants';
import { hasAuthTokens } from '../../../util/auth-tokens.util';
import { LookupService } from '../../../services/lookup/lookup.service';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

@Component({
    standalone: false,
    selector: 'cva-login',
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss',
    
})
export class LoginComponent implements OnInit {
  errMsg: string = '';
  loginForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.minLength(4)])
  })
  routes_constants = ROUTE_CONSTANTS;
  PRIVACY_POLICY_ROUTE = ROUTE_CONSTANTS.PRIVACY_POLICY;
  TnC_ROUTE = ROUTE_CONSTANTS.TERMS_AND_CONDITIONS;
  passwordVisible: boolean = false
  cvaUI_url = environment.cvaUI_url
  constructor(public readonly router: Router,
    private readonly loginService: LoginService,
    private readonly customLoginService: CustomLoginService,
    private readonly lookupService: LookupService,
    private recaptchaV3Service: ReCaptchaV3Service,
  ) { }

  ngOnInit() {
    console.log("Login page called, checking for presence of active session");
    this.loginService.isLoggedIn().subscribe({
      next: (res) => {
        this.handleLoginResponse(res);
      },
      error: () => {
        console.log("No active session found. Continue with login");
        this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
      }
    });

    this.loginForm.valueChanges.subscribe(() => {
      this.errMsg = '';
    });
  }

  private async handleLoginResponse(res: boolean) {
    console.log("Active session found, redirecting to landing page");
    const hasTokens = hasAuthTokens();
    if (res && hasTokens) {
      await this.lookupService.initSpeechService();
      this.router.navigate([environment.landingURL]);
    } else if (res) {
      console.log("Session cookies found but auth tokens missing. Staying on login.");
      this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
    } else {
      this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
    }
  }

  validateForm(form: FormGroup) {
    for (const control in form.controls) {
      const element = form.controls[control] as FormControl
      if (!element.valid) {
        element.markAsDirty()
      }
    }
  }
  submitForm() {
    console.log("Validating login form");
    if (!this.loginForm.valid) {
      this.validateForm(this.loginForm);
      console.log("Invalid login form");
      return
    }
    console.log("Login form validated. Calling login service");
    const userDetails = this.loginForm.value;

    this.recaptchaV3Service.execute('loginAction').subscribe({
      next: (token: string) => {
        this.customLoginService.login({ ...userDetails, token, action: 'loginAction' }).subscribe({
          // eslint-disable-next-line  @typescript-eslint/no-explicit-any
          next: (res: any) => {
            if (res.body?.twoStepVerification) {
              this.router.navigate([ROUTE_CONSTANTS.TWO_STEP_VERIFICATION], {
                queryParams: { email: userDetails.email }
              });
              return;
            }
            console.log("Login successful, redirecting to landing page");
            const redirectUrl = res.body?.redirectUrl;
            if (redirectUrl) {
              window.location.href = redirectUrl;
              this.loginService.loggedIn$.next(true);
            } else {
              this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
              this.loginService.loggedIn$.next(false);
            }
          },
          error: (err) => {
            console.log("Login failed");
            if (err?.message) {
              this.errMsg = err?.message || CVA_CONSTANTS.MESSAGE.invalid_credentials;
            } else {
              this.errMsg = CVA_CONSTANTS.MESSAGE.UNKNOWN_LOGIN_ERR;
            }

            if (err?.resetLink) {
              this.loginService.redirectToResetPassword(err.resetLink);
            }
          }
        })
      },
      error: (error) => {
        console.log("Error while fetching reCAPTCHA token");
        if (error?.message) {
          this.errMsg = error?.message
        } else {
          this.errMsg = 'Error occurred while validating CAPTCHA';
        }
      }
    })

  }
  setInputType() {
    this.passwordVisible = !this.passwordVisible
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }

}
